import React from "react";
import { createFormikFields } from "@components/forms/fields/createFormikFields";
import { Button } from "@design-system/Button/Button";
import { pluralizeWithCount } from "@common/helpers/string";
import { EntityAvatarGroup } from "@components/avatar/EntityAvatarGroup";
import styles from "./SendingEmailEntitiesField.module.scss";

/** The slice of the add and edit sending email forms this field binds to. */
interface SendingEmailEntitiesValues {
    entityIds: number[];
}

const fields = createFormikFields<SendingEmailEntitiesValues>();

export const SendingEmailEntitiesField: React.FC = () => (
    <fields.Entity
        name="entityIds"
        label="Entities"
        optional
        labelTooltip="Leave empty to make this address available to every entity."
        className={styles.field}
        renderTrigger={({ triggerProps, selectedEntities }) => (
            <Button {...triggerProps} type="button" variant="primary" size="xl">
                {selectedEntities.length ? (
                    <EntityAvatarGroup
                        entities={selectedEntities}
                        max={3}
                        size="xs"
                        label={pluralizeWithCount(
                            "Entity",
                            selectedEntities.length,
                        )}
                    />
                ) : (
                    "All entities"
                )}
            </Button>
        )}
    />
);
